module.exports = __webpack_public_path__ + "static/knitcat-f88f9187ab819e90e3954bec9c58631d.jpeg";